(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["toasty-stockists"] && !Shopify.designMode) return;
  try {
    
(function () {
  const init = scope => {
    const root = scope.querySelector('#toasty-finder[data-editable]');
    if (!root || root.dataset.bound) return;
    root.dataset.bound = 'true';
    const $ = selector => root.querySelector(selector);
    const cards = [...root.querySelectorAll('[data-store]')];
    const labels = JSON.parse($('[data-finder-labels]').textContent);
    const stores = cards.map(card => ({card, id:card.dataset.store, retailer:card.dataset.retailer, region:card.dataset.region, branch:card.querySelector('h3').textContent, lat:Number(card.dataset.lat), lng:Number(card.dataset.lng)}));
    let retailer='all', selected='', map, layer, loading;
    const safe = text => String(text).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    const track = (action, store, extra={}) => {
      const payload={action,outlet_id:store?.id||'',outlet_name:store?store.retailer+' · '+store.branch:'',retailer:store?.retailer||retailer,region:store?.region||'all',page_path:location.pathname,page_name:'stockists',...extra};
      try { window.Shopify?.analytics?.publish('toasty_location_action',payload)?.catch?.(()=>{}); } catch (_) {}
      root.dispatchEvent(new CustomEvent('toasty:location-action',{detail:payload}));
    };
    const results = () => stores.filter(s => retailer==='all'||s.retailer===retailer);
    const select = id => {
      selected=id;
      cards.forEach(card => card.dataset.selected=String(card.dataset.store===id));
      const store=stores.find(s=>s.id===id);
      if(store) $('.tt-cards').scrollTop=store.card.offsetTop;
      layer?.eachLayer(marker => marker.getElement()?.classList.toggle('tt-pin-selected',marker.options.toastyIds.includes(id)));
    };
    const markers = fit => {
      if(!map) return;
      layer.clearLayers();
      const locations=new Map();
      results().forEach(store => {
        if(!Number.isFinite(store.lat)||!Number.isFinite(store.lng)) return;
        const key=store.lat+','+store.lng;
        if(!locations.has(key))locations.set(key,[]);
        locations.get(key).push(store);
      });
      locations.forEach(group=>{
        const store=group[0], ids=group.map(s=>s.id);
        const title=group.map(s=>s.retailer+' · '+s.branch).join('; ');
        const marker=window.L.marker([store.lat,store.lng],{keyboard:true,toastyIds:ids,title,alt:title,icon:window.L.divIcon({className:ids.includes(selected)?'tt-pin-selected':'',html:'<div class="tt-map-pin" aria-hidden="true"></div>',iconSize:[32,40],iconAnchor:[16,38],popupAnchor:[0,-34]})}).addTo(layer);
        marker.getElement().setAttribute('aria-label',title);
        marker.bindPopup(group.map(s=>'<div class="tt-popup-store"><strong>'+safe(s.retailer)+'</strong><br>'+safe(s.branch)+'<br><a href="'+safe(s.card.querySelector('[data-directions]').href)+'" target="_blank" rel="noopener noreferrer" data-directions="'+safe(s.id)+'">'+safe(labels.directions)+'</a></div>').join(''),{maxHeight:200,autoPanPadding:[20,20]});
        marker.on('click',()=>{select(store.id);track('map_pin',group.length===1?store:null,group.length>1?{outlet_id:'',outlet_name:store.branch,retailer:store.retailer,region:store.region,location_id:store.lat+','+store.lng}:{});});
      });
      const bounds=results().filter(s=>Number.isFinite(s.lat)&&Number.isFinite(s.lng)).map(s=>[s.lat,s.lng]);
      if(fit&&bounds.length) map.fitBounds(bounds,{padding:[36,36],maxZoom:14,animate:false});
    };
    const render = () => {
      const visible=results();
      stores.forEach(s=>{s.card.hidden=!visible.includes(s);s.card.querySelector('.tt-store-top').hidden=retailer!=='all';});
      $('[data-result-count]').textContent=labels.count.replace('COUNT',visible.length);
      $('[data-empty]').hidden=visible.length>0;
      root.querySelectorAll('[data-retailer-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.retailerFilter===retailer)));
      select('');
      $('.tt-cards').scrollTop=0;
      markers(true);
    };
    const loadMap = () => {
      if(loading) return loading;
      loading=new Promise((resolve,reject)=>{
        const start=()=>{try{
          $('#tt-map').textContent='';
          map=window.L.map($('#tt-map'),{scrollWheelZoom:false,center:[1.354,103.836],zoom:11});
          map.attributionControl.setPrefix('');
          window.L.tileLayer('https://www.onemap.gov.sg/maps/tiles/Default/{z}/{x}/{y}.png',{maxZoom:19,minZoom:10,attribution:'<a href="https://www.onemap.gov.sg/" target="_blank" rel="noopener noreferrer">OneMap</a> © contributors | <a href="https://www.sla.gov.sg/" target="_blank" rel="noopener noreferrer">Singapore Land Authority</a>'}).addTo(map);
          layer=window.L.layerGroup().addTo(map);markers(true);resolve(map);
        }catch(e){reject(e);}};
        if(window.L?.map){start();return;}
        if(!document.querySelector('link[data-toasty-leaflet]')){const css=document.createElement('link');css.rel='stylesheet';css.href='https://www.onemap.gov.sg/web-assets/libs/leaflet/leaflet.css';css.dataset.toastyLeaflet='true';document.head.appendChild(css);}
        const script=document.createElement('script');script.src='https://www.onemap.gov.sg/web-assets/libs/leaflet/onemap-leaflet.js';script.onload=start;script.onerror=reject;document.head.appendChild(script);
      }).catch(()=>{$('#tt-map').textContent=labels.map_error;return null;});
      return loading;
    };
    root.addEventListener('click',async e=>{
      const retailerButton=e.target.closest('[data-retailer-filter]');
      if(retailerButton){retailer=retailerButton.dataset.retailerFilter;render();track('retailer_filter');}
      const directions=e.target.closest('[data-directions]');
      if(directions)track('directions',stores.find(s=>s.id===directions.dataset.directions));
      const show=e.target.closest('[data-map-store]');
      if(show){const store=stores.find(s=>s.id===show.dataset.mapStore);const loaded=await loadMap();if(!loaded||!store)return;select(store.id);loaded.setView([store.lat,store.lng],15,{animate:false});layer.eachLayer(m=>{if(m.options.toastyIds.includes(store.id))m.openPopup();});$('#tt-map-panel').scrollIntoView({block:'center',behavior:'auto'});track('show_on_map',store);}
      const action=e.target.closest('[data-tt-action]');
      if(action)track(action.dataset.ttAction,null,{outlet_id:action.dataset.outletId||'',event_id:action.dataset.eventId||''});
    });
    root.addEventListener('auxclick',e=>{if(e.button!==1)return;const a=e.target.closest('[data-directions]');if(a)track('directions',stores.find(s=>s.id===a.dataset.directions));});
    const expireEvents=()=>root.querySelectorAll('[data-event-end]').forEach(card=>{const end=Date.parse(card.dataset.eventEnd);card.hidden=Number.isFinite(end)&&Date.now()>end;});
    expireEvents();
    const timer=setInterval(expireEvents,60000);
    render();loadMap();
    const selectBlock=e=>{
      const card=e.target.closest('[data-store]');
      if(card&&root.contains(card)){retailer='all';render();select(card.dataset.store);}
    };
    const unload=e=>{if(e.target.contains(root)){clearInterval(timer);map?.remove();document.removeEventListener('shopify:block:select',selectBlock);document.removeEventListener('shopify:section:unload',unload);}};
    document.addEventListener('shopify:section:unload',unload);
    document.addEventListener('shopify:block:select',selectBlock);
  };
  init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();


  } catch(e) { console.error(e); }
})();
})();
